import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { Link } from 'core/routing';

import { TagIndicator } from 'apps/tag/index';

import {
  Tag,
  Divider,
  SubPageStatsWrapper,
  SubPageStatName,
  SubPageStat,
} from 'legacyComponents/styled/lib';
import { Participants } from 'legacyComponents/layout/participants';

import { withNamespaces, Trans } from 'react-i18next';

@withNamespaces()
@observer
export class SubPageStats extends React.Component {
  render() {
    const { loading, tags, participants, button } = this.props;
    const tagList = [];

    if (loading) {
      tagList.push(
        <div key='loading-tags'>
          <ListTagIndicator />
          <ListTagIndicator />
          <ListTagIndicator />
        </div>,
      );
    }
    if (!loading) {
      // FIXME - replace with map
      // eslint-disable-next-line
      for (const tag of tags) {
        tagList.push(
          <Link name='channel' params={{ channel: tag.name }} key={tag.id}>
            <Tag vertical>#{tag.name}</Tag>
          </Link>,
        );
      }
    }

    return (
      <SubPageStatsWrapper>
        <SubPageStatName first>
          <Trans>Tags</Trans>
        </SubPageStatName>
        {tagList}
        <SubPageStatName>
          <Trans>Participants</Trans>
          {participants && participants.length > 0 ? (
            <Count> ({participants.length})</Count>
          ) : (
            ''
          )}
        </SubPageStatName>
        {loading ? (
          <SubPageStat>
            <Trans>Loading...</Trans>
          </SubPageStat>
        ) : participants.length === 0 ? (
          <SubPageStat>
            <Trans>None yet</Trans>
          </SubPageStat>
        ) : (
          <Participants participants={participants} />
        )}
        {button ? (
          <div>
            <Divider width='100%' />
            {button}
          </div>
        ) : (
          ''
        )}
      </SubPageStatsWrapper>
    );
  }
}

const Count = styled.span`
  color: ${props => props.theme.color.wfGrey500};
`;

const ListTagIndicator = styled(TagIndicator)`
  width: 70px;
  height: 22px;
  display: table;
  margin-right: 0px;
  margin-bottom: 15px;
  margin-left: 20px;
`;

SubPageStats.propTypes = {
  loading: PropTypes.bool,
  tags: PropTypes.object,
  participants: PropTypes.object,
  button: PropTypes.node,
};
